export default {
  navigation: {
    homepage: 'الرئيسية',
    profile: 'ملفي الشخصي',
    editProfile: 'تعديل ملفي الشخصي',
    changePassword: 'تغيير كلمة المرور',
    devices: 'أجهزتي',
    services: 'خدماتي',
    disableAccess: 'تعطيل الوصول إلى منصة'
  },
  email: 'البريد الإلكتروني',
  username: 'البريد الإلكتروني أو الهاتف أو اسم المستخدم (INS, RPPS, ...)',
  password: 'كلمة المرور',
  newPassword: 'كلمة المرور الجديدة',
  firstName: {
    view: 'الاسم الأول',
    edition: 'الاسم الأول (مثال: جان، مارك، فيكتور)'
  },
  lastName: 'اسم العائلة',
  birthName: 'اسم الولادة',
  speciality: 'التخصص',
  category: 'الفئة',
  address: 'العنوان',
  type: 'النوع',
  phone: 'الهاتف المحمول',
  birthDate: 'تاريخ الميلاد (يوم/شهر/سنة)',
  birthDateUser: 'تاريخ الميلاد',
  birthPlaceInsee: 'رمز INSEE لمدينة الميلاد',
  birthDateNotSpecified: 'غير محدد',
  phoneNotSpecified: 'غير محدد',
  sex: 'الجنس',
  sexChoice: {
    male: 'ذكر',
    female: 'أنثى',
    unknown: 'غير محدد'
  },
  gender: 'النوع الاجتماعي',
  ins: 'رقم INS',
  oid: 'OID',
  parentIns: 'رقم INS للوالد',
  myInformations: 'معلوماتي الشخصية',
  contactInformation: 'معلومات الاتصال الخاصة بي',
  information: 'معلوماتي',
  profile: 'ملفي الشخصي',
  passwordChoice: 'تحديد كلمة المرور الخاصة بي',
  passwordHint: 'يجب أن تحتوي على 8 أحرف على الأقل، بما في ذلك رقم واحد، حرف صغير واحد، وحرف كبير واحد.',
  patient: {
    label: 'المريض',
    identifier: 'رقم الضمان الاجتماعي',
    firstNameUsed: 'الاسم الأول المستخدم',
    lastNameUsed: 'اسم العائلة المستخدم'
  },
  professional: {
    label: 'المهني',
    identifier: 'المعرف (RPPS, ADELI, أخرى (FINESS, SIRET, SIREN, DRASS))',
    job: 'الوظيفة',
    jobSpecialty: 'التخصص'
  },
  trustedDevices: {
    title: 'أجهزتي المعروفة',
    subtitle: 'ستجد جميع أجهزتك المعروفة',
    noDevice: 'لا توجد أجهزة معروفة',
    refresh: 'تحديث',
    userAgent: 'الجهاز',
    ip: 'عنوان IP',
    moreDevice: 'عرض أجهزتي',
    creationDate: 'تمت الإضافة في',
    lastUsed: 'آخر استخدام',
    deleteDevice: 'حذف هذا الجهاز',
    alert: {
      title: 'حذف جهاز معروف',
      content: 'لن يُعتبر الجهاز "{userAgent}" معروفًا بعد الآن، وستحتاج إلى التحقق المزدوج للوصول.'
    }
  }
}
